__turbopack_context__.v({
  "eyebrow": "AiCallAgentServicesCardSection-module__v6VmRW__eyebrow",
  "section": "AiCallAgentServicesCardSection-module__v6VmRW__section",
  "title": "AiCallAgentServicesCardSection-module__v6VmRW__title",
});
